/**
 * CalendarHeader Component
 * Top header with create event and settings buttons
 */

import React from 'react';
import { Button } from 'primereact/button';
import { useCalendarUI } from 'modules/calendarv2/context/CalendarUIContext';

const CalendarHeader = () => {
  const { openSettingsModal, openEventFormModal, sidebarCollapsed, toggleSidebar } = useCalendarUI();

  return (
    <div className="calendar-v2-header">
      <div className="header-left">
        {/* Mobile sidebar toggle - only visible on mobile via CSS */}
        <Button
          icon={sidebarCollapsed ? 'pi pi-users' : 'pi pi-times'}
          onClick={toggleSidebar}
          className="mobile-sidebar-toggle"
          aria-label={sidebarCollapsed ? 'Open Team Calendars' : 'Close Team Calendars'}
        />
        <h1 className="title gray-800 mb-0">Calendar</h1>
      </div>

      <div className="header-right">
        <Button label="Create Event" icon="pi pi-plus" onClick={() => openEventFormModal('create')} className="p-button p-button-primary" />
        <div className="list-view gear-icon cal-gear" onClick={openSettingsModal}>
          <i className="icon-Setting cursor-pointer"></i>
        </div>
      </div>
    </div>
  );
};

export default React.memo(CalendarHeader);
